var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"skeleton",staticClass:"message-image"},[_c('img',{staticClass:"message-image",attrs:{"src":_setup.data.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }